export default "__VITE_ASSET__cb786b32__"